/*
    CompanyUsername should only contain small letters and - . _ as well as numbers
*/
export function domainRule(
  message = "Darf nur Kleinbuchstaben enthalten und . enthalten. Keine Sonderzeichen, Keine großbuchstaben, keine Zahlen"
): (value: any) => boolean | string {
  const companyUserNameRegEx = RegExp(/^[a-z0-9-.]*$/);
  return value => companyUserNameRegEx.test(value) || message;
}
